import { useMemo } from 'react'
import { SecureStateType } from '../../constants/enums'
import {
    ageGateWordFilter,
    filterAndReplaceBadWords,
} from '../../utilities/ageGate'
import { useSecureState, useSecureStateSelector } from './useSecureState'

interface BadWordFilterProps {
    topic?: string
    username?: string
    messageText?: string
    replaceWith?: string
}

interface BadWordFilterResults extends BadWordFilterProps {
    ageGateActive: boolean
}

function useBadWordFilter(props: BadWordFilterProps): BadWordFilterResults {
    const { messageText, topic, username, replaceWith } = props
    const { ageGateActive } = useSecureState(SecureStateType.AGE_VERIFICATION)
    const filteredWords: BadWordFilterResults = {
        ageGateActive,
        ...(topic
            ? { topic: ageGateActive ? filterAndReplaceBadWords(topic) : topic }
            : {}),
        ...(messageText
            ? {
                  messageText: ageGateActive
                      ? filterAndReplaceBadWords(messageText)
                      : messageText,
              }
            : {}),
        ...(username
            ? {
                  username: ageGateActive
                      ? filterAndReplaceBadWords(username, replaceWith)
                      : username,
              }
            : {}),
    }

    return filteredWords
}

export const useAgeGateWordFilter = () => {
    const ageGateActive = useSecureStateSelector(
        SecureStateType.AGE_VERIFICATION,
        'ageGateActive',
    )
    return useMemo(() => ageGateWordFilter(!!ageGateActive), [ageGateActive])
}

export default useBadWordFilter
